import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";

import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import { MyUrl } from "../../../App";
import axios from "axios";

var MyArray = [];
export default function IncomeSecondTable({
  TotalOfDailyChange,
  SendDataToSecondTable,
  startDate,
  endDate,
  CheckTypeOfUser,
}) {
  const [Value, setValue] = React.useState("");

  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const gridRef = useRef(); // Optional - for accessing Grid's API
  const [rowData, setRowData] = useState(); // Set rowData to Array of Objects, one Object per Row
  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [height, width] = useWindowSize();
  // Each Column Definition results in one Column.
  const [columnDefs, setColumnDefs] = useState([
    {
      flex: width > 766 ? 1 : null,
      field: "date",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",

      //   headerCheckboxSelection: true,
      //   headerCheckboxSelectionFilteredOnly: true,
      //   checkboxSelection: true,
    },
    {
      headerName: "Ad Requests",
      field: "addRequests",
      filter: true,
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      headerClass: "my-header-class",

      valueFormatter: (params) =>
        `${params.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },
    {
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "impressions",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",

      valueFormatter: (params) =>
        `${params.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },
    {
      headerName: "Revenue",
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      field: "revenueTotal",
      filter: "agNumberColumnFilter",
      headerClass: "my-header-class",

      valueFormatter: (params) =>
        `$${params.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },
    // {
    //   hide: CheckTypeOfUser === "Partner",

    //   minWidth: 150,
    //   flex: width > 766 ? 1 : null,
    //   field: "scannedImpressions",
    //   filter: "agNumberColumnFilter",
    //   headerClass: "my-header-class",

    //   valueFormatter: (params) =>
    //     `${params.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    // },

    {
      field: "mediaCost",
      filter: true,
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      headerClass: "my-header-class",

      valueFormatter: (params) =>
        `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },
    // {
    //   field: "marketplacefee",
    //   filter: true,
    //   minWidth: 150,
    //   flex: width > 766 ? 1 : null,
    //   headerClass: "my-header-class",

    //   valueFormatter: (params) =>
    //     `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    // },
    {
      field: "servingFee",
      filter: true,
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      headerClass: "my-header-class",

      valueFormatter: (params) =>
        `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },
    {
      headerName: "Scanning fee",

      field: "scanningfee",
      filter: true,
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      headerClass: "my-header-class",

      valueFormatter: (params) =>
        `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },
    {
      field: "grossProfit",
      filter: true,
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      headerClass: "my-header-class",
      valueFormatter: (params) =>
        `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },
    {
      headerName:
        CheckTypeOfUser === "Partner" ? "Partner Net Income" : "Net income",

      field: "netIncome",
      filter: true,
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      headerClass: "my-header-class",
      valueFormatter: (params) =>
        `$ ${params.value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    },
    {
      headerName: "Daily Change",
      field: "netIncome1",
      filter: true,
      minWidth: 150,
      flex: width > 766 ? 1 : null,
      headerClass: "my-header-class",

      cellStyle: (params) => {
        const prevValue = params.api.getDisplayedRowAtIndex(params.rowIndex - 1)
          ?.data[params.colDef.field];
        const currentValue = params.data[params.colDef.field];
        params.prevValue = prevValue; // Store prevValue as a property of the params object

        if (prevValue && currentValue > prevValue) {
          return { backgroundColor: "green", color: "black" };
        } else if (prevValue && currentValue < prevValue) {
          return { backgroundColor: "red", color: "black" };
        } else {
          return null;
        }
      },
      valueFormatter: (params) => {
        const currentValue = params.value;
        const prevValue = params.data.prevNetIncome;
        const AfterCalc = currentValue - prevValue;
        for (let i = 1; i < SendDataToSecondTable.length; i++) {
          SendDataToSecondTable[i].prevNetIncome =
            SendDataToSecondTable[i - 1].netIncome;
        }
        if (prevValue && currentValue > prevValue) {
          return `$  ${AfterCalc.toFixed(2).replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ","
          )} ↑ `;
        } else if (prevValue && currentValue < prevValue) {
          return `$ ${AfterCalc.toFixed(2).replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ","
          )} ↓`;
        } else {
          return `$ ${currentValue
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        }
      },
    },
  ]);

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(() => ({
    sortable: true,
  }));
  // Example of consuming Grid Event
  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  // Example using Grid's API
  const buttonListener = useCallback((e) => {
    gridRef.current.api.deselectAll();
  }, []);
  var ragCellClassRules = {
    "rag-green-outer": function (params) {
      return params.value === 2008;
    },
    "rag-amber-outer": function (params) {
      return params.value === 2004;
    },
    "rag-red-outer": function (params) {
      return params.value === 2000;
    },
  };
  const [selectedRows, setSelectedRows] = useState([]);
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    // console.log(rowData);
    setGridApi(params.api);
  };

  const getRowHeight = (params) => (params.node.group ? 40 : 40);
  const sumRow = {
    date: "Total",
    //date: SendDataToSecondTable.reduce((acc, curr) => acc + curr.date, 0),

    impressions: SendDataToSecondTable.reduce(
      (acc, curr) => acc + curr.impressions,
      0
    ),
    // scannedImpressions: SendDataToSecondTable.reduce(
    //   (acc, curr) => acc + curr.scannedImpressions,
    //   0
    // ),
    revenueTotal: SendDataToSecondTable.reduce(
      (acc, curr) => acc + curr.revenueTotal,
      0
    ),
    addRequests: SendDataToSecondTable.reduce(
      (acc, curr) => acc + curr.addRequests,
      0
    ),

    mediaCost: SendDataToSecondTable.reduce(
      (acc, curr) => acc + curr.mediaCost,
      0
    ),
    marketplacefee: SendDataToSecondTable.reduce(
      (acc, curr) => acc + curr.marketplacefee,
      0
    ),

    servingFee: SendDataToSecondTable.reduce(
      (acc, curr) => acc + curr.servingFee,
      0
    ),
    scanningfee: SendDataToSecondTable.reduce(
      (acc, curr) => acc + curr.scanningfee,
      0
    ),
    grossProfit: SendDataToSecondTable.reduce(
      (acc, curr) => acc + curr.grossProfit,
      0
    ),
    netIncome: SendDataToSecondTable.reduce(
      (acc, curr) => acc + curr.netIncome,
      0
    ),
    netIncome1: TotalOfDailyChange / (SendDataToSecondTable.length - 1),
    // procentNetIncome: SendDataToSecondTable.reduce(
    //   (acc, curr) => acc + curr.procentNetIncome,
    //   0
    // ),
  };

  const gridOptions = {
    getRowStyle: (params) => {
      if (params.node.rowPinned === "bottom") {
        return { backgroundColor: "#f9f8f9" };
      }
    },
    rowClass: (params) => {
      return params.node.rowIndex === SendDataToSecondTable.length
        ? "bottom-row"
        : "";
    },
    // other grid options...
  };

  //   const columnDefs = [
  //     { headerName: "Name", field: "name" },
  //     { headerName: "Value", field: "value" },
  //   ];
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  useEffect(() => {
    // This code will run only when myVariable changes
    console.log(`startDate changed to ${startDate} ---- ${endDate}`);
  }, [startDate, endDate]);
  return (
    <div style={{ paddingTop: 30, paddingBottom: 30 }}>
      <div style={containerStyle}>
        <div style={gridStyle} className="ag-theme-alpine">
          <span style={{ color: "#1a1523", fontSize: 18 }}>
            Income Channel Overview
            {/* <span style={{ color: "#e4e2e4" }}> • </span>{" "}
            <span style={{ color: "#6f6e77" }}>{startDate}</span> */}
          </span>
          <AgGridReact
            cellClassRules={ragCellClassRules}
            ref={gridRef} // Ref for accessing Grid's API
            rowData={SendDataToSecondTable} // Row Data for Rows //{[...SendDataToSecondTable, sumRow]} add another column had a total values
            columnDefs={columnDefs} // Column Defs for Columns
            defaultColDef={defaultColDef} // Default Column Properties
            animateRows={true} // Optional - set to 'true' to have rows animate when sorted
            rowSelection="multiple" // Options - allows click selection of rows
            onCellClicked={cellClickedListener} // Optional - registering for Grid Event
            onGridReady={onGridReady}
            gridOptions={gridOptions}
            pinnedBottomRowData={[sumRow]}
            suppressScrollOnNewData={true}
            getRowHeight={getRowHeight}
            domLayout="autoHeight"
          />
        </div>{" "}
      </div>{" "}
      <style>
        {`
          .ag-theme-alpine .ag-root-wrapper {
            border: none;
          }
        `}
        {`
          .my-header-class {
            background-color: white;
          }
        `}
      </style>
    </div>
  );
}
